<template>
  <div class="tooltip-wrapper">
    <vwc-icon-button
        class="cd-tooltip-icon-button"
        :icon="toolTipInfo.icon"
        shape="rounded"
        @mouseenter="openTooltip=true"
        @mouseleave = "openTooltip=false"
        :dense="dense"
    ></vwc-icon-button>
    <vwc-tooltip
        :open="openTooltip"
        :icon="toolTipInfo.icon"
        :text="toolTipInfo.text"
        :anchor="toolTipInfo.id"
        :corner="corner"
    ></vwc-tooltip>
  </div>
</template>

<script>
export default {
  name: "CdTooltip",
  props: {
    toolTipInfo : {
      type: Object,
      default: null,
    },
    dense : {
      type: Boolean,
      default: false
    },
    corner : {
      type : String,
      default : "left"
    }
  },
  data() {
    return {
      openTooltip :false
    }
  },
}
</script>

<style scoped>

.tooltip-wrapper{
  display: flex;
  align-items: center;
  z-index: 99;
}

.cd-tooltip-icon-button {
  --vvd-icon-button-icon-size: 32px;
}

</style>
